<template>
  <section>
    <div class="default-modal blue-background">
      <el-dialog v-model="dialogVisible" width="60%" @close="close">
        <div class="dialog-header">
          <span class="header-part"> Changed Details </span>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table :data="selectedData" style="width: 100%">
                  <el-table-column prop="key" label="Field Name">
                    <template #default="{ row }">
                      {{ formatKey(row.key) || "--"}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="previous_value"
                    label="Initial Data"
                  />
                  <el-table-column prop="present_value" label="Updated Data" />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn">
          <el-button @click="close">Close</el-button>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
export default {
  props: ["selectedData"],
  data() {
    return {
      dialogVisible: true,
    };
  },
  methods: {
    formatKey(key) {
      return key
        .replace(/_/g, " ")
        .replace(/\./g, " - ")
        .replace(/^\w/, (c) => c.toUpperCase());
    },
    close() {
      this.dialogVisible = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss">
.close-btn {
    text-align: end;
    padding: 0 1rem 0.5rem;
    .el-button {
      min-height: 30px;
      padding: 0 1.3rem;
      color: #ffffff;
      background-color: #eb5757;
      border-radius: 7px;
      border: none;
      &:hover,
      &:focus {
        background-color: #eb5757;
        color: #ffffff;
        border: none;
      }
    }
  }
</style>